import React, { useEffect, createElement } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { PricingSection } from '../PricingSection';
export const PricingPage = () => {
  useEffect(() => {
    document.title = 'Pricing — Maestro Connect';
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Simple pricing for music teachers. Start your free trial today.';
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-6032">
      <Navbar data-id="element-6033" />
      <main className="pt-20" data-id="element-6034">
        <PricingSection data-id="element-6035" />
      </main>
      <Footer data-id="element-6036" />
    </div>;
};